// removed by extract-text-webpack-plugin
module.exports = {"container":"by_g"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Container/styles.module.css
// module id = 1051
// module chunks = 27